import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from "@angular/core";
import {VisitConfigurationModel} from "../../../models/visit-configuration.model";
import {
  DEFAULT_VISIT_CONFIGURATIONS_COLUMN_WIDTHS,
  VISIT_CONFIGURATIONS_TABLE_UNIQUE_ID
} from "../../../constants/visit-configurations-table-column-widths.constant";

const ROW_HEIGHT = 60;

require('./visit-configurations-table.scss');
@Component({
  standalone: false,
  selector: 'app-visit-configurations-table',
  templateUrl: './visit-configurations-table.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitConfigurationsTableComponent implements OnChanges {

  @Input() visitConfigurations: VisitConfigurationModel[];
  @Input() showAccountColumn?: boolean;
  @Input() isLoading: boolean;
  @Input() selectedIds: string[] = [];
  @Output() reloadEvent = new EventEmitter<any>();
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() onEdit = new EventEmitter<VisitConfigurationModel>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onSelectVisitConfigurations = new EventEmitter<string[]>();

  public readonly tableUniqueId: string = VISIT_CONFIGURATIONS_TABLE_UNIQUE_ID;
  public readonly defaultWidths: { [key: string]: number } = DEFAULT_VISIT_CONFIGURATIONS_COLUMN_WIDTHS;
  public readonly rowHeight: number = ROW_HEIGHT;

  public selectedKeys: { [id: string]: boolean } = {};

  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedIds) {
      this.selectedKeys = {};
      (this.selectedIds || []).forEach(id => this.selectedKeys[id] = true);
    }
  }

  onToggleSelectVisitConfiguration(id: string, isSelected: boolean) {
    this.selectedKeys = {...this.selectedKeys, [id]: isSelected};
    this.onSelectVisitConfigurations.emit(
      Object.keys(this.selectedKeys).filter(key => this.selectedKeys[key])
    );
  }

}
